import { Metadata } from 'next'

const metadata: Metadata = {
  title: 'Shipsticks',
  description:
    'Best Golf Club Shipper 6 years in a row by Golf Digest. ' +
    'We offer white-glove, door-to-door shipping services worldwide. ' +
    'Get a FREE quote today!',
  icons: {
    icon: [
      { url: '/shipsticks.favicon.png', type: 'image/png' },
      { url: '/shipsticks.favicon.ico' },
    ],
  },
  alternates: {
    canonical: 'https://www.shipsticks.com',
  },
}

export default metadata
